import { render, staticRenderFns } from "./VerticalAlert.vue?vue&type=template&id=681f2dbb&scoped=true"
import script from "./VerticalAlert.vue?vue&type=script&lang=ts"
export * from "./VerticalAlert.vue?vue&type=script&lang=ts"
import style0 from "./VerticalAlert.vue?vue&type=style&index=0&id=681f2dbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681f2dbb",
  null
  
)

export default component.exports